import type { PosthogConversationsRemoteConfig } from "config/posthog-client";

export type PostHogConversationsApi = {
  isAvailable: () => boolean;
  isVisible: () => boolean;
  show: () => void;
  hide: () => void;
  onRemoteConfig: (config: { conversations?: PosthogConversationsRemoteConfig }) => void;
};

export type PostHogWithConversations = {
  conversations?: PostHogConversationsApi;
};

export type PostHogClientWithSupportIdentity = {
  config: {
    identity_distinct_id?: string;
    identity_hash?: string;
  };
  setIdentity: (distinctId: string, identityHash: string) => void;
  clearIdentity: () => void;
};

export const isPosthogSupportIdentityConfigured = (
  posthog: PostHogClientWithSupportIdentity
): boolean => {
  const distinctId = posthog.config.identity_distinct_id?.trim();
  const identityHash = posthog.config.identity_hash?.trim();
  return Boolean(distinctId && identityHash);
};
